import request from '@/utils/request'
export default {
    getPaymentLogs: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get', url: 'payment-log', params: {
                ...Object.select(params, ['paymentId', 'column', 'direction'])
            }
        })
            .then(res => {
                if (res.data && res.data.paymentLogs) {
                    commit('SET_PAYMENT_LOGS', res.data.paymentLogs)
                    commit('SET_LOAD', false)
                }
            })
    }
}
